<ngx-loading [show]="loading"></ngx-loading>

<div class="container-fluid p-4">
  <div class="row">
    <div class="col-md-12">
      <h2>{{company?.name}}</h2>
    </div>
    <div class="col-md-12">
      <div class="rounded px-4 py-3 mt-2" style="background-color: #dbe0e7; font-size: 15px;">
        {{company?.address1 || ''}} {{company?.address2 || ''}} {{company?.city || ''}} {{company?.postal_code || ''}} {{company?.region || ''}} {{company?.country || ''}}
      </div>
    </div>
  </div>
</div>

<div class="container-fluid px-4" style="background-color: #ebeff5;" *ngIf="isRCDSS">
  <div class="row">

      <div class="col-md-12">

        <div class="row p-4 m-0 border bg-white rounded shadow">
          <div class="col-md-12">
            
            <ngx-company-users
              [company]="company"
            ></ngx-company-users>

          </div>
        </div>
        
      </div>
  </div>
</div>